<template>
  <div class="admin-wrapper">
    <!-- Edit user button -->
    <!-- <h2 class="subtitle">
      <a :href="`/user/${user._id}/settings`">Edit User</a>
    </h2> -->
    <br />

    <el-tabs v-model="infoTabs" @tab-click="handleClick">
      <!-- customer info-->
      <el-tab-pane label="Customer Info" name="first">
        <h2 class="title" style="text-align: left">Customer Info</h2>
        <el-row :gutter="10" v-if="this.user._id">
          <el-col :xs="24" :sm="24" :md="12">
            <!-- user card -->
            <el-card class="box-card" shadow="hover">
              <div slot="header" class="clearfix">
                <span>Update User Record</span>
              </div>
              <el-form ref="userForm" :model="user">
                <!-- User Name -->
                <el-form-item label="Name">
                  <el-input v-model="user.name"></el-input>
                </el-form-item>
                <el-form-item label="Last Name">
                  <el-input v-model="user.lastName"></el-input>
                </el-form-item>
                <!-- Email address -->
                <el-form-item label="Email">
                  <el-input v-model="user.email"></el-input>
                </el-form-item>
                <el-form-item label="User Work Role">
                  <el-select v-model="user.workRole" placeholder="">
                    <el-option
                      v-for="item in workRoleOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <!-- Email Verification -->
                <el-form-item label="Is Email Verified?">
                  <el-switch v-model="user.emailVerified"></el-switch>
                </el-form-item>
                <!-- Stinger enabled -->
                <!-- <el-form-item label="Is Stinger Enabled?">
                  <el-switch v-model="user.stinger"></el-switch>
                </el-form-item> -->
                <!-- email enabled -->
                <el-form-item label="Video Complete Notification">
                  <el-switch v-model="emailNotifications"></el-switch>
                </el-form-item>
                <el-form-item label="App Updates Notification">
                  <el-input v-model="user.emailAppUpdates"></el-input>
                </el-form-item>
                <el-form-item label="Newsletter Notification">
                  <el-switch v-model="emailnewsletterNotifications"></el-switch>
                </el-form-item>
                <el-form-item label="Billing Notification">
                  <el-switch v-model="emailBillingNotifications"></el-switch>
                </el-form-item>
                <el-form-item label="Billing Email">
                  <el-input v-model="user.emailToBilling"></el-input>
                </el-form-item>
                <!-- video plan -->
                <!-- <el-form-item label="Video Plan">
                  <el-select v-model="user.products.video" placeholder="">
                    <el-option label="Free" value="free"></el-option>
                    <el-option label="Creator Monthly" value="creator_monthly"></el-option>
                    <el-option label="Creator Annual" value="creator_annual"></el-option>
                    <el-option label="Influencer Monthly" value="influencer_monthly"></el-option>
                    <el-option label="Influencer Annual" value="influencer_annual"></el-option>
                    <el-option label="Agency Monthly" value="agency_monthly"></el-option>
                    <el-option label="Agency Annual" value="agency_annual"></el-option>
                    <el-option label="Network Monthly" value="network_monthly"></el-option>
                    <el-option label="Network Annual" value="network_annual"></el-option>
                    <el-option label="Alpha Monthly (retired)" value="alpha10"></el-option>
                    <el-option label="Alpha Annual (retired)" value="alpha365"></el-option>
                    <el-option label="Beta Monthly (retired)" value="beta18"></el-option>
                    <el-option label="Beta Annual (retired)" value="beta365"></el-option>
                    <el-option label="Gamma Monthly (retired)" value="gamma32"></el-option>
                    <el-option label="Gamma Annual (retired)" value="gamma365"></el-option>
                    <el-option label="Pro Monthly (retired)" value="pro60"></el-option>
                    <el-option label="Pro Annual (retired)" value="pro600"></el-option>
                  </el-select>
                </el-form-item> -->
                <!-- link plan -->
                <!-- <el-form-item label="Link Plan">
                  <el-select v-model="user.products.link" placeholder="">
                    <el-option label="Free" value="free"></el-option>
                    <el-option label="Link Included" value="link_included"></el-option>
                    <el-option label="Link Monthly (retired)" value="link_9"></el-option>
                    <el-option label="Link Annual (retired)" value="link_90"></el-option>
                  </el-select>
                </el-form-item> -->

                <!-- role -->
              </el-form>
            </el-card>
          </el-col>
          <!-- stripe and stats col -->
          <el-col :xs="24" :sm="24" :md="12">
            <!-- stats card -->
            <el-card class="box-card" shadow="hover">
              <div slot="header" class="clearfix">
                <span>Actions</span>
              </div>
              <div>
                <el-button class="has-margin-top" round type="warning" @click="saveUserForm"
                  >SAVE User Info</el-button
                >
                <el-button class="has-margin-top" round type="info" @click="launchPasswordModal()"
                  >RESET Password</el-button
                >
                <el-button
                  class="has-margin-top"
                  round
                  type="danger"
                  @click="launchCancelPlanModal()"
                  >CANCEL plan</el-button
                >
                <el-button class="has-margin-top" round type="danger" @click="deleteUser"
                  >DELETE user</el-button
                >
                <el-button
                  class="has-margin-top"
                  round
                  type="danger"
                  @click="removeSeat"
                  v-if="this.user.stripePlan.seats > 3"
                  >REMOVE seat</el-button
                >
                <!-- <el-button type="danger" @click="launchDeleteModal()">DELETE User Record</el-button> -->
              </div>
            </el-card>
            <el-card class="box-card" shadow="hover">
              <div slot="header" class="clearfix">
                <span>User Stats</span>
              </div>
              <table>
                <!-- date added -->
                <tr v-if="this.user.dateAdded" style="border-bottom: 1px solid black">
                  <th style="width: 50%">Customer Since</th>
                  <th style="width: 50%; text-align: right">{{ this.user.dateAdded | moment }}</th>
                </tr>
                <tr v-else style="border-bottom: 1px solid black">
                  <th style="width: 50%">Customer Since</th>
                  <th style="width: 50%; text-align: right">
                    No Record Found, Investigate Further
                  </th>
                </tr>
                <!-- total videos -->
                <tr style="border-bottom: 1px solid black">
                  <th style="width: 50%">Total Videos</th>
                  <th style="width: 50%; text-align: right">
                    {{
                      this.user.jobs.length >= 1
                        ? this.user.jobs.length
                        : "No Record Found, Investigate Further"
                    }}
                  </th>
                </tr>
                <tr style="border-bottom: 1px solid black">
                  <th style="width: 50%">Total Transcriptions</th>
                  <th style="width: 50%; text-align: right">
                    {{ this.user.totalTranscriptions }}
                  </th>
                </tr>
              </table>
            </el-card>
            <!-- Stripe card -->
            <el-card class="box-card" shadow="hover">
              <div slot="header" class="clearfix">
                <span>Stripe Info</span>
              </div>
              <div class="block has-margin-bottom" v-if="user.stripePlan.isTrial">
                <div>
                  Add Trial Days - Date to end:
                  <b>{{ addDays(hasTrialTimeLeft ? this.user.stripePlan.currentPeriodEnd : new Date(), trialsDayToAdd) }}</b>
                </div>
                <el-form>
                  <el-form-item>
                    <el-input-number
                      class="has-margin-right"
                      type="number"
                      placeholder="Pick a day"
                      v-model="trialsDayToAdd"
                    />
                    <el-button
                      class="has-margin-top"
                      round
                      type="info"
                      :disabled="trialsDayToAdd === 0"
                      @click="changeUserTrial"
                      >SAVE</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
              <table>
                <!-- stripe ID -->
                <tr style="border-bottom: 1px solid black">
                  <th style="width: 50%">Stripe ID</th>
                  <td style="width: 50%; text-align: right">
                    <a
                      target="_blank"
                      v-bind:href="'https://dashboard.stripe.com/customers/' + this.user.stripe.id"
                      v-if="this.user.stripe.id"
                    >
                      {{ this.user.stripe.id }}
                    </a>
                    <span v-else>NA</span>
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid black">
                  <th class="has-margin-right" style="width: 50%">Plan</th>
                  <td style="width: 50%; text-align: right">{{ this.user.stripePlan.planName }}</td>
                </tr>
                <tr style="border-bottom: 1px solid black">
                  <th class="has-margin-right" style="width: 50%">Plan Active</th>
                  <td style="width: 50%; text-align: right">
                    {{ this.user.stripePlan.active ? "Active" : "Inactive" }}
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid black">
                  <th style="width: 50%">Additional Seats</th>
                  <td style="width: 50%; text-align: right">
                    3 + {{ this.user.stripePlan.seats - 3 }}
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid black" v-if="!this.user.stripePlan.isTrial">
                  <th style="width: 50%">Plan Price</th>
                  <td style="width: 50%; text-align: right">
                    ${{ this.user.stripePlan.price }}/{{ this.user.stripePlan.interval }}
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid black" v-if="!this.user.stripePlan.isTrial">
                  <th style="width: 50%">Stripe Status</th>
                  <td style="width: 50%; text-align: right">{{ this.user.stripePlan.status }}</td>
                </tr>
                <tr style="border-bottom: 1px solid black" v-if="this.user.stripePlan.isCanceled">
                  <th style="width: 50%">Subscription Canceled</th>
                  <td style="width: 50%; text-align: right">Yes</td>
                </tr>
                <tr style="border-bottom: 1px solid black">
                  <th style="width: 50%">
                    {{
                      this.user.stripePlan.isTrial
                        ? "End date"
                        : this.user.stripePlan.isCanceled
                        ? "Cancelation Date"
                        : "Renew Date"
                    }}
                  </th>
                  <td style="width: 50%; text-align: right">
                    <template v-if="this.user.stripePlan.isTrial">
                      <span v-if="!this.user.trialRedeem"> 21 </span>
                      <span v-else-if="hasTrialTimeLeft">
                        {{ this.user.stripePlan.currentPeriodEnd | moment }}

                        (Days left: <b>{{ this.user.stripePlan.currentPeriodEnd | daysLeft }}</b
                        >)
                      </span>
                      <span v-else> Without trial </span>
                    </template>
                    <template v-else>
                      {{ this.user.stripePlan.currentPeriodEnd | moment }}

                      (Days left: <b>{{ this.user.stripePlan.currentPeriodEnd | daysLeft }}</b
                      >)
                    </template>
                  </td>
                </tr>
              </table>
            </el-card>
            <!-- Wavve Link card -->
            <el-card class="box-card" shadow="hover">
              <div slot="header" class="clearfix">
                <span>Wavve Link Info</span>
              </div>
              <div v-if="this.user.links.length > 0">
                <table
                  class="has-margin-bottom"
                  v-for="(link, index) in this.user.links"
                  :key="link._id"
                >
                  <tr style="border-bottom: 1px solid black">
                    <th style="width: 50%">Link {{ index + 1 }}</th>
                  </tr>
                  <tr style="border-bottom: 1px solid black">
                    <th style="width: 50%">Title</th>
                    <th style="width: 50%">{{ link.title }}</th>
                  </tr>
                  <tr style="border-bottom: 1px solid black">
                    <th style="width: 50%">RSS</th>
                    <th style="width: 50%">
                      <a v-bind:href="link.feed" target="_blank">
                        {{ link.feed }}
                      </a>
                    </th>
                  </tr>
                  <tr style="border-bottom: 1px solid black">
                    <th style="width: 50%">Short ID</th>
                    <th style="width: 50%">
                      <a v-bind:href="'http://wavve.link/' + link.shortId" target="_blank">
                        {{ link.shortId }}
                      </a>
                    </th>
                  </tr>
                  <tr>
                    <th style="width: 50%">Custom Link</th>
                    <th style="width: 50%">
                      <a v-bind:href="'http://wavve.link/' + link.slug" target="_blank">
                        {{ link.slug }}
                      </a>
                    </th>
                  </tr>
                </table>
              </div>
              <div v-else>No Data</div>
            </el-card>
          </el-col>
        </el-row>
      </el-tab-pane>

      <!-- User Video History -->
      <el-tab-pane label="Video History" name="third">
        <h1 class="title">User Videos</h1>
        <el-table
          :data="jobData"
          :summary-method="getTotalTime"
          show-summary
          align="center"
          style="width: 100%"
        >
          <el-table-column label="Date Added" width="120">
            <template slot-scope="scope">
              {{ scope.row.date_added | moment }}
            </template></el-table-column
          >
          <el-table-column label="Duration" width="150">
            <template slot-scope="scope">
              {{ scope.row | duration }}
            </template>
          </el-table-column>
          <el-table-column label="Status" width="150">
            <template slot-scope="scope">
              {{ scope.row.status }}
            </template>
          </el-table-column>

          <el-table-column label="Operations" width="600px">
            <template slot-scope="scope">
              <el-button size="mini" @click="showJobDetails(scope.row)"> View</el-button>
              <el-button
                :disabled="scope.row.status === 'Free Credit'"
                size="mini"
                type="success"
                @click="creditJobTime(scope.row)"
                >Credit</el-button
              >
              <el-button
                :disabled="scope.row.status === 'complete'"
                size="mini"
                type="info"
                @click="retryJob(scope.row)"
                >Retry</el-button
              >
              <el-button size="mini" type="danger" @click="showReassignModel(scope.row)"
                >Re-assign</el-button
              >
              <a :href="`https://app.wavve.co/transcribe/${scope.row.guid}`" target="_blank">
                <el-button class="has-margin-left" size="mini" type="info">Edit Captions</el-button>
              </a>
              <el-button
                :disabled="!scope.row.deleted"
                class="has-margin-left"
                size="mini"
                type="danger"
                @click="updateDeleteStatusOfJob(scope.row)"
                >Recover</el-button
              >
              <el-button
                :disabled="scope.row.deleted"
                class="has-margin-left"
                size="mini"
                type="danger"
                @click="updateDeleteStatusOfJob(scope.row)"
                >Delete</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <br /><br />
      </el-tab-pane>

      <!-- User Themes -->
      <el-tab-pane label="Design History" name="fourth">
        <h1 class="title">User Designs</h1>
        <el-table :data="themeData" style="width: 100%" align="center">
          <el-table-column label="Image" width="200">
            <template slot-scope="scope">
              <img :src="designImageSRCLink + scope.row.backgroundImage" :width="150" />
            </template>
          </el-table-column>
          <el-table-column label="Name" width="200">
            <template slot-scope="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column label="Card Type" width="140">
            <template slot-scope="scope">
              {{ scope.row.cardType }}
            </template>
          </el-table-column>
          <el-table-column label="Pattern" width="120">
            <template slot-scope="scope">
              {{ scope.row.pattern }}
            </template>
          </el-table-column>
          <el-table-column label="Deleted" width="120">
            <template slot-scope="scope">
              {{ scope.row.deleted }}
            </template>
          </el-table-column>
          <el-table-column label="Staged" width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.isStaged" style="color: green">
                <span> Staged</span>
              </div>
              <div v-else>
                <span>Not Staged</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Operations" width="200">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button type="text">
                  Action<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    ><el-button type="text" @click="handleThemeAction(scope.row, 'view')"
                      >View</el-button
                    ></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><a :href="`https://app.wavve.co/editor/${scope.row._id}`" target="_blank"
                      ><el-button type="text">Edit</el-button></a
                    ></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><el-button type="text" @click="handleThemeAction(scope.row, 'share')"
                      >Share</el-button
                    ></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><el-button type="text" @click="handleThemeAction(scope.row, 'stage')"
                      >Stage</el-button
                    ></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column> </el-table
        ><br />
      </el-tab-pane>

      <!-- media library -->
      <el-tab-pane label="Media Library" name="fifth">
        <h1 class="title">User Media Library</h1>
        <el-table :data="userJobs" style="width: 100%" align="center">
          <el-table-column label="" width="70">
            <template slot-scope="scope">
              <img :src="scope.row.image_src" width="50" height="50" />
            </template>
          </el-table-column>

          <el-table-column label="Library Item" width="200">
            <template slot-scope="scope">
              {{ scope.row.title }}
            </template>
          </el-table-column>

          <el-table-column label="Date Added" width="200">
            <template slot-scope="scope">
              {{ scope.row.date_added }}
            </template>
          </el-table-column>

          <el-table-column label="Status" width="200">
            <template slot-scope="scope">
              {{ scope.row.status }}
            </template>
          </el-table-column>

          <el-table-column label="Download Link" width="200">
            <template slot-scope="scope">
              <a :href="scope.row.audio_url">Download</a>
            </template>
          </el-table-column> </el-table
        ><br />
      </el-tab-pane>

      <!-- end tabs -->
    </el-tabs>

    <!-- RESET PASSWORD -->
    <el-dialog title="Reset Password" :visible.sync="passwordModalVisible">
      <el-form
        ref="dataForm"
        label-position="left"
        label-width="70px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="User">
          <b>Email:</b>
          {{ user.email }}
          <br />
        </el-form-item>
        <el-form-item label="Notes">
          <el-input
            v-model="newPassword"
            class="has-small-margin-top"
            placeholder="New Password"
          ></el-input>
          <el-input
            v-model="confirmNewPassword"
            class="has-small-margin-top"
            placeholder="Confirm New Password"
          ></el-input>
          <br />
          <br />
          <el-input
            v-model="editReason"
            :autosize="{ minRows: 2, maxRows: 4 }"
            type="textarea"
            placeholder="Update Reason"
          />
        </el-form-item>
      </el-form>
      <div class="tip danger">
        Warning:
        <b>{{ user.email }}</b
        >'s password will be changed immediately.
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" class="has-margin-left" @click="updateUserPassword()"
          >RESET PASSWORD</el-button
        >
      </div>
    </el-dialog>
    <!-- CANCEL PLAN -->
    <el-dialog title="Cancel Plan" :visible.sync="cancelPlanModalVisible">
      <el-form
        ref="dataForm"
        label-position="left"
        label-width="70px"
        style="width: 400px; margin-left: 50px"
      >
        <!-- <el-form-item label="Notes">
          <el-input v-model="editReason" :autosize="{ minRows: 2, maxRows: 4 }" type="textarea"
            placeholder="Update Reason" />
        </el-form-item> -->
      </el-form>
      <div class="tip danger">
        Warning: <b>{{ user.email }}</b
        >'s plan will be cancelled immediately.
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" class="has-margin-left" @click="cancelUserPlan()"
          >CANCEL PLAN</el-button
        >
      </div>
    </el-dialog>
    <!-- DELETE USER -->
    <el-dialog title="DELETE USER" :visible.sync="deleteModalVisible">
      <el-form
        ref="dataForm"
        label-position="left"
        label-width="70px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="Notes">
          <el-input
            v-model="editReason"
            :autosize="{ minRows: 2, maxRows: 4 }"
            type="textarea"
            placeholder="Update Reason"
          />
        </el-form-item>
      </el-form>
      <div v-if="user.products">
        <div class="tip danger" v-if="user.stripePlan.active">
          Warning: This user still has a subscription attached. Do not delete until this has been
          addressed.
        </div>
      </div>
      <div class="tip danger">
        Warning:
        <b>{{ user.email }}</b> will be permanently deleted.
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" class="has-margin-left" @click="deleteUser()">DELETE</el-button>
      </div>
    </el-dialog>
    <!-- JOB PREVIEW MODAL -->
    <el-dialog title="Job Details" :visible.sync="jobDetailVisible" :key="jobSelected.guid">
      <video controls ref="video">
        <source
          :src="`https://sls-wavve-out.s3.amazonaws.com/${jobSelected.guid}.mp4`"
          type="video/mp4"
        />
      </video>
      <pre>{{ jobSelected }}</pre>
      <div slot="footer" class="dialog-footer">
        <el-button type="text" @click="hideJobDetails()">Dismiss</el-button>
        <a :href="`https://sls-wavve-out.s3.amazonaws.com/${jobSelected.guid}.mp4`" target="_blank">
          <el-button type="primary" class="has-margin-left">Download Video</el-button>
        </a>
        <a :href="`https://s3.amazonaws.com/subtitles-out/${jobSelected.guid}.mp4`" target="_blank">
          <el-button type="primary" class="has-margin-left">Download Video W/ Captions</el-button>
        </a>
        <a
          :href="`https://s3.amazonaws.com/sls-wavve-in/tmp/${jobSelected.guid}/audiofile`"
          target="_blank"
        >
          <el-button type="primary" class="has-margin-left">Download Original Audio</el-button>
        </a>
      </div>
    </el-dialog>

    <el-dialog title="Design Details" :visible.sync="themeDetailVisible">
      <p class="tip primary">Note that this is a simplified rendering and may not be accurate.</p>
      <design-animated-preview
        v-if="themeSelected"
        :design="themeSelected"
      ></design-animated-preview>
      <pre>{{ themeSelected }}</pre>
      <div slot="footer" class="dialog-footer">
        <el-button @click="themeDetailVisible = false">Dismiss</el-button>
      </div>
    </el-dialog>

    <!-- JOB RE-ASSIGN MODAL -->
    <el-dialog title="Re-assign Video" :visible.sync="jobReassignVisible" :key="jobSelected._id">
      <p class="tip primary">Enter email address of new user below</p>

      <el-form ref="videoReassignForm" :model="videoReassignForm" label-width="120px">
        <el-form-item label="Email">
          <el-input v-model="videoReassignForm.newEmailAddress"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button
          @click="
            reassignJob(jobSelected._id, videoReassignForm.newEmailAddress, $store.state.user.email)
          "
          >Apply</el-button
        >
        <el-button @click="jobReassignVisible = false">Dismiss</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable new-cap */

import moment from "moment";
import AwsService from "@/api/aws.service";
import AdminService from "@/api/admin.service";
import DesignAnimatedPreview from "@/components/Create/DesignAnimatedPreview.vue";
import Theme from "@/store/models/Theme";
import "@/style/admin.scss";
import ThemeService from "@/api/theme.service";

const { rrwebPlayer } = window;

const workRoleOptions = [
  { value: "author", label: "Author" },
  { value: "organization-association-non-profit", label: "Association-Organization-Non-profit" },
  { value: "church-marketer", label: "Church Marketer" },
  { value: "company-brand", label: "Company or Brand" },
  { value: "digital-publishing", label: "Digital Magazine-Blog-Newsletter" },
  { value: "educator", label: "Educator" },
  { value: "influencer-podcaster", label: "Influencer Podcaster" },
  { value: "live-audio-room-host", label: "Live Audio Room Host" },
  { value: "marketing-consultant", label: "Marketing Consultant-Agency" },
  { value: "media-company", label: "Media Company" },
  { value: "music-producer", label: "Music Producer" },
  { value: "new-podcaster", label: "New Podcaster" },
  { value: "podcast-production-agency", label: "Podcast Production Agency" },
  { value: "radio-show-host", label: "Radio Station Show Host" },
  { value: "record-label", label: "Record Label" },
  { value: "singer-musician", label: "Singer or Musician" },
  { value: "speaker", label: "Speaker" },
  { value: "vlogger-streamer", label: "Vlogger or Live Streamer" },
  { value: "voice-artist", label: "Voice Artist" },
];

export default {
  name: "user",
  components: {
    DesignAnimatedPreview,
  },
  computed: {
    emailNotifications: {
      get() {
        return !this.user.emailOptOut;
      },
      set(value) {
        this.user.emailOptOut = !value;
      },
    },
    emailnewsletterNotifications: {
      get() {
        return !this.user.emailNewsletter;
      },
      set(value) {
        this.user.emailNewsletter = !value;
      },
    },
    emailBillingNotifications: {
      get() {
        return !this.user.emailBilling;
      },
      set(value) {
        this.user.emailBilling = !value;
      },
    },
    hasTrialTimeLeft() {
      return (
        this.user.stripePlan.isTrial &&
        new Date(this.user.stripePlan.currentPeriodEnd) >= Date.now()
      );
    },
  },
  filters: {
    moment: (date) => moment(date).format("YYYY-MM-DD"),
    duration: (row) => {
      const time = Math.round(row.specs.end - row.specs.start);
      return `${time} seconds`;
    },
    daysLeft: (date) => {
      if (new Date(date).getTime() < Date.now()) {
        return 0;
      }

      const now = Date.now();
      const diffTime = Math.abs(new Date(date).getTime() - now);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      return diffDays;
    },
  },
  data() {
    return {
      workRoleOptions,
      userJobs: [],
      videoReassignForm: {
        newEmailAddress: "",
      },
      trialsDayToAdd: 0,
      infoTabs: "first",
      userData: this.user,
      user: {
        name: "",
        cards: [],
        jobs: [],
      },
      designImageSRCLink: "https://s3-us-west-2.amazonaws.com/wavvegram/background/",
      jobData: null,
      themeData: null,
      jobSelected: {},
      themeSelected: {},
      jobDetailVisible: false,
      jobReassignVisible: false,
      userDetailVisible: false,
      themeDetailVisible: false,
      me: this.$store.state.user,
      events: [],
      messageAccordians: [],
      deleteModalVisible: false,
      passwordModalVisible: false,
      cancelPlanModalVisible: false,
      newPassword: "",
      confirmNewPassword: "",
      editReason: "",
    };
  },
  watch: {
    jobDetailVisible(val) {
      if (val === false) {
        this.$refs.video.pause();
      }
    },
  },
  created() {
    this.getUser();
  },

  mounted() {
    this.initPlayer();
  },

  methods: {
    addDays: (date, days) => {
      const momentDate = moment(date).add({
        days,
      });

      return momentDate.format("YYYY-MM-DD");
    },
    async handleThemeAction(rowID, action) {
      console.log(this.themeData);
      if (action === "view") {
        this.showThemeDetails(rowID);
      }
      if (action === "share") {
        this.cloneTheme(rowID);
      }
      if (action === "stage") {
        this.stageToShareTheme(rowID);
      }
    },
    async deleteUser() {
      try {
        const confirmData = {
          confirmButtonText: "Delete User",
          cancelButtonText: "Nevermind",
          dangerouslyUseHTMLString: true,
        };
        await this.$confirm(
          "Are you sure you wan't to delete the user?",
          "DANGER: DELETE USER",
          confirmData
        );
      } catch (err) {
        this.$message.error({
          message: `Abandoned user delete for ${this.user.email}`,
        });
        return;
      }

      try {
        await AdminService.deleteUser(this.user._id, { email: this.user.email });
        this.$notify.success({
          title: "Success",
          message: "Seat removal complete",
        });
        this.cancelPlanModalVisible = false;
      } catch (err) {
        this.$notify.error({ title: "Error", message: "Seat removal failed" });
      }
    },
    async removeSeat() {
      try {
        const confirmData = {
          confirmButtonText: "Remove Seat",
          cancelButtonText: "Nevermind",
          dangerouslyUseHTMLString: true,
        };
        await this.$confirm(
          "Are you sure you wan't to remove a user seat?",
          "DANGER: REMOVE SEAT",
          confirmData
        );
      } catch (err) {
        this.$message.error({
          message: `Abandoned plan removal seat for ${this.user.email}`,
        });
        return;
      }

      try {
        await AdminService.removeSeat(this.user._id);
        this.$notify.success({
          title: "Success",
          message: "Seat removal complete",
        });
        this.cancelPlanModalVisible = false;
      } catch (err) {
        this.$notify.error({ title: "Error", message: "Seat removal failed" });
      }
    },
    async cancelUserPlan() {
      try {
        const confirmData = {
          confirmButtonText: "Cancel Plan",
          cancelButtonText: "Nevermind",
          dangerouslyUseHTMLString: true,
        };
        await this.$confirm(
          "Are you sure you wan't to cancel the user plan?",
          "DANGER: CANCEL PLAN",
          confirmData
        );
      } catch (err) {
        this.$message.error({
          message: `Abandoned plan change for ${this.user.email}`,
        });
        return;
      }

      // Proceed with plan pause request
      try {
        await AdminService.cancelPlan(this.user._id);
        this.$notify.success({
          title: "Success",
          message: "Cancel plan complete",
        });
        this.cancelPlanModalVisible = false;
      } catch (err) {
        this.$notify.error({ title: "Error", message: "Cancel plan failed" });
      }
    },
    async updateUserPassword() {
      if (this.newPassword !== this.confirmNewPassword) {
        this.$message.error({ message: "Your passwords did not match." });
        return;
      }

      // Safety check for admin to confirm correct user's password being reset
      try {
        const message =
          "You are about to reset the password for:" +
          `<pre><strong>${this.user.email}</strong></pre><br>` +
          "<strong>Double check the user name before proceeding.</strong>";
        const confirmData = {
          confirmButtonText: "Reset Password",
          cancelButtonText: "Nevermind",
          dangerouslyUseHTMLString: true,
        };
        await this.$confirm(message, "DANGER: PASSWORD RESET", confirmData);
      } catch (err) {
        this.$message.error({
          message: `Abandoned password change for ${this.user.email}`,
        });
        return;
      }

      // Proceed with password reset request
      try {
        // add action.message
        const payload = {
          newPassword: this.newPassword,
          message: this.editReason,
        };
        await AdminService.updateUserPassword(this.user._id, payload);
        await this.$store.dispatch("SYNC_USER_TO_DB");
        this.newPassword = "";
        this.confirmNewPassword = "";
        this.$message.success({
          message: `${this.user.email}'s password was updated.`,
        });
        this.passwordModalVisible = false;
      } catch (err) {
        if (err.response && err.response.data) {
          this.$message.error({ message: err.response.data.message });
        } else {
          this.$message.error({ message: "Unable to change password" });
        }
      }
    },
    launchDeleteModal() {
      this.deleteModalVisible = true;
    },
    launchPasswordModal() {
      this.passwordModalVisible = true;
    },
    launchCancelPlanModal() {
      this.cancelPlanModalVisible = true;
    },
    async saveUserForm() {
      if (this.user.role === "admin") {
        this.$confirm(
          "Danger!!! You are about to make this user an admin. Do you want to continue?",
          "Warning",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        )
          .then(() => {
            this.finishUpdatingUserRecord();
          })
          .catch(() => {
            this.user.role = "owner";
            this.$message({
              type: "info",
              message: "Update Canceled",
            });
          });
        console.log("Updated User Info", this.user);
      } else {
        this.finishUpdatingUserRecord();
      }
    },
    async finishUpdatingUserRecord() {
      let regex = new RegExp("[a-z0-9]+@[a-z]+\.[a-z]{2,3}");
      if (regex.test(this.user.email)) {
        console.log("I'm going to update the user record now");
        // --------------
        // --------------
        const payload = {
          user: this.user,
        };
        const response = await AdminService.updateUserRecord(payload);
        if (response === "success") {
          this.$message({
            type: "info",
            message: "Update Completed",
          });
        } else {
          this.$message({
            type: "info",
            message: response,
          });
        }
      } else {
        this.$notify({
          title: "Email Invalid",
          message: ("i", { style: "color: teal" }, "Check Email Address"),
        });
      }
    },
    async handleClick(tab, event) {
      console.log(tab, event);
    },

    async updateDeleteStatusOfJob(row) {
      const deleteStatus = !row.deleted;
      const confData = {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      };
      try {
        await this.$confirm("Recover deleted job?", "Warning", confData);
        await AdminService.updateJob(row._id, {
          deleted: deleteStatus,
          status: row.status,
        });
        this.getUser();
        this.$message.success({
          message: "Job recovered",
        });
      } catch (err) {
        console.log("error", err);
        this.$message.info({
          message: "Job recover canceled",
        });
      }
    },

    async getDeflections() {
      const id = window.location.pathname.split("/").pop();
      const res = await AdminService.getDeflectorData(id);
      console.log("res", res);
      this.events = res;
    },
    async playRecording() {
      try {
        // let events = JSON.parse(evt.target.result);
        const id = window.location.pathname.split("/").pop();
        const data = await AdminService.getDeflectorData(id);
        // eslint-disable-next-line no-new
        new rrwebPlayer({
          target: document.getElementById("player"),
          data: {
            events: data,
            autoPlay: true,
          },
        });
      } catch (err) {
        console.log(err);
      }
    },
    initPlayer() {
      this.playRecording();
      // this.getDeflections();
    },
    // get user's lifetime usage
    getTotalTime(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (column.label !== "Duration") {
          return;
        }

        if (!data || data.length === 0) {
          sums[index] = "N/A";

          return;
        }

        const values = data.map((i) => Math.round(i.specs.end - i.specs.start));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            }
            return prev;
          }, 0);
          sums[index] = `${sums[index]} total seconds`;
        } else {
          sums[index] = "N/A";
        }
      });
      return sums;
    },

    async getUser() {
      const id = window.location.pathname.split("/").pop();
      this.user = await AdminService.getUser(id);
      this.jobData = this.user.jobs.reverse();
      this.themeData = this.user.cards;
      this.userJobs = await AdminService.getUserLibrary(id);
      console.log(this.userJobs);
      console.log("User Info:", this.user);
    },

    async creditJobTime(row) {
      const confData = {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      };
      try {
        await this.$confirm("Credit user's account back for video time?", "Warning", confData);
        await AdminService.updateJob(row._id, {
          message: "User requested time back.",
          status: "Free Credit",
          deleted: row.deleted,
        });
        this.getUser();
        this.$message.success({
          message: "Account credited",
        });
      } catch (err) {
        console.log("error", err);
        this.$message.info({
          message: "Credit canceled",
        });
      }
    },

    async reassignJob(vidID, email, adminEmail) {
      const confData = {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      };

      try {
        await this.$confirm("Are you sure you want to re-assign this video?", "Warning", confData);
        const response = await AdminService.reassignVideo({
          message: "Admin re-assign video to another user.",
          status: "Reassign",
          id: vidID,
          email,
          adminEmail,
        });
        console.log(response);
        this.getUser();
        this.$message.success({
          message: "Complete",
        });
      } catch (err) {
        this.$message.info({
          message: "Error: User not found.",
        });
      }
      this.jobReassignVisible = false;
    },

    async retryJob(data) {
      data.specs.uuid = data.guid;
      const job = {
        uuid: data.guid,
        start: data.specs.start,
        end: data.specs.end,
        title: data.theme,
        theme: data.specs,
        isDemoTheme: this.user.cards.length === 0, // fallback to demo theme if user has no themes
      };
      try {
        await AwsService.startLambda(job);
        this.$message.success({
          message: `Resubmitted job #${job.uuid}.`,
        });
      } catch (err) {
        this.$message.error({
          message: err,
        });
      }
    },

    async changeUserTrial() {
      const confData = {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      };

      try {
        await this.$confirm(
          "Are you sure you want to change the trial of this user?",
          "Warning",
          confData
        );

        const date = moment(this.hasTrialTimeLeft ? new Date(this.user.stripePlan.currentPeriodEnd) : new Date())
          .add({
            days: this.trialsDayToAdd,
          })
          .endOf("day");

        await AdminService.changeUserTrial(this.user._id, date.utcOffset(0, true).format());

        this.user.trialEndAt = date.utcOffset(0, true).toDate();
        this.user.stripePlan.currentPeriodEnd = this.user.trialEndAt;

        this.$message.success({
          message: "Complete",
        });
      } catch (err) {
        console.error(err);

        this.$message.info({
          message: "Error: error to update user trial.",
        });
      }

      this.trialsDayToAdd = 0;
    },

    showJobDetails(row) {
      this.jobDetailVisible = true;
      this.jobSelected = row;
    },

    showReassignModel(row) {
      this.jobReassignVisible = true;
      this.jobSelected = row;
    },

    showUserDetails() {
      this.userDetailVisible = true;
    },

    showThemeDetails(row) {
      this.themeDetailVisible = true;
      this.themeSelected = new Theme(row);
    },

    cloneTheme(row) {
      console.log("row-----------");
      console.log(row._id);

      this.$prompt("Who do you want to share this theme with?", "Share Theme", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        inputPattern:
          /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: "Invalid Email",
      })
        .then(({ value }) => {
          const data = {
            id: row._id,
            user: value,
          };
          ThemeService.clone(data).then((response) => {
            console.log("response", response);
            this.$message({
              type: "Status",
              message: response,
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Canceled",
          });
        });
    },

    stageToShareTheme(row) {
      console.log("row-----------");
      console.log(row._id);
      const data = {
        id: row._id,
      };
      ThemeService.stageToShareTheme(data).then((response) => {
        this.$message({
          type: "info",
          message: response,
        });
      });
    },
    editTheme(row) {
      console.log("row", row);
      // TODO - add admin theme edit functionality
      // this.action = {id: row.id, name: row.name, plan: row.plan, type};
      // this.$nextTick(() => this.$refs['dataForm'].clearValidate());
    },
  },
};
</script>

<style>
.danger-zone button {
  margin: 0 auto;
  display: block;
  width: 200px;
  margin-top: 1em;
}

.subtitle a {
  text-decoration: underline;
  font-weight: bold;
}

#replayer {
  border: 1px solid red;
  min-height: 500px;
  width: 100%;
}
</style>
